import { MultiEmailInputV2, CustomButton, CustomInput } from '@/shared/ui/components';
import _ from 'lodash';
import { t } from 'ttag';
import { useWebPortalIssues } from './useWebPortalIssues';
import SEND_REQUEST from '../submitARequest.constants';
import type { WebPortalIssuesProps } from './webPortalIssues.types';
import './styles.scss';

const WebPortalIssues = ({
  category,
  selectedFacility,
  setLoadingPage,
  backToPrevious,
}: WebPortalIssuesProps) => {
  const { state, onChange, onClickSendMessage, onChangeEmailList, onInputChange } =
    useWebPortalIssues({ category, selectedFacility, setLoadingPage, backToPrevious });

  return (
    <div className="web-portal-issues">
      <div className="message-box">
        <span className="big-title">Message</span>
        <CustomInput
          className="message-text"
          placeholder={t`Enter your message`}
          type="textarea"
          value={state.message}
          onChange={onChange}
          name="message"
          allowClear={false}
        />
      </div>

      <div className="email-box">
        <span className="big-title">{t`Notification email`}</span>
        <MultiEmailInputV2
          emailList={state.emailList}
          emailInputValue={state.emailInputValue}
          onChangeEmailList={onChangeEmailList}
          onInputChange={onInputChange}
          isError={!_.isEmpty(state.errorObject.invalidEmails)}
          errorMessage={state.errorObject.invalidEmails}
        />
      </div>

      <div className="bottom-button-row">
        <CustomButton
          id="submit-btn"
          className="button-submit"
          disabled={
            (_.isEmpty(state.emailList) && !state.emailInputValue) ||
            !state.message ||
            state.isSaving
          }
          onClick={() => {
            setTimeout(onClickSendMessage, 100);
          }}
        >
          {SEND_REQUEST}
        </CustomButton>
      </div>
    </div>
  );
};

export default WebPortalIssues;
